// extracted by mini-css-extract-plugin
export default {"title":"UploadErrorModal_title__ryT30","body":"UploadErrorModal_body__t7I0t"};